/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductionOrderManualModeFinishingDataViewModel } from '../../models/production-order-manual-mode-finishing-data-view-model';

export interface GetManualModeFinishingData$Params {
  productionOrderId: number;
}

export function getManualModeFinishingData(http: HttpClient, rootUrl: string, params: GetManualModeFinishingData$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductionOrderManualModeFinishingDataViewModel>> {
  const rb = new RequestBuilder(rootUrl, getManualModeFinishingData.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductionOrderManualModeFinishingDataViewModel>;
    })
  );
}

getManualModeFinishingData.PATH = '/api/v1/ProductionOrder/{productionOrderId}/GetManualModeFinishingData';
